import { render, staticRenderFns } from "./ClientChatLogs.vue?vue&type=template&id=49f092c6&scoped=true"
import script from "./ClientChatLogs.vue?vue&type=script&lang=js"
export * from "./ClientChatLogs.vue?vue&type=script&lang=js"
import style0 from "./ClientChatLogs.vue?vue&type=style&index=0&id=49f092c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f092c6",
  null
  
)

export default component.exports